import alert from '../components/alerts'

const useAxios = (deleteBtn) => {
  const endpoint = deleteBtn.getAttribute('delete-product')

  axios.delete(endpoint)
  .then(function (response) {
    deleteBtn.closest('tr').remove()
    window.location.reload()
  })
  .catch(function (error) {
    new alert().custom('success', {title: 'Hay un problema', content: 'No se ha podido eliminar el producto, intentalo de nuevo'})
  })
}

const DeleteProduct = () => {
  const deleteBtns = document.querySelectorAll('[delete-product]')

  if(!deleteBtns.length > 0) return

  deleteBtns.forEach((deleteBtn) => {
    deleteBtn.addEventListener('click', e => {
      e.preventDefault()

      useAxios(deleteBtn)
    })
  })
}
export default DeleteProduct
